import { Injectable } from "@angular/core";

import { environment } from "../../../environments/environment";

@Injectable()
export class AppSettingsService {
  InternalUIBase: string = environment.internalBase;
  PortalApiBaseUrl: string = environment.portalApiBaseUrl;
  CommonApiBaseUrl: string = environment.commonApiBaseUrl;
  IsProductionMode: boolean = environment.production;
  IsDebugEnabled: boolean = environment.debugMode;
  ExternalLinks = environment.externalLinks;
  IsCompatibilityMode: boolean = this.isDateInputSupported() === false;
  MessageCenterBaseUrl: string = environment.messageCenterBaseUrl;
  MessageCenterAppKey: string = environment.messageCenterAppKey;
  MessageCenterAppSecret: string = environment.messageCenterAppSecret;
  private isDateInputSupported() {
    const input = document.createElement("input");
    input.setAttribute("type", "date");

    const notADateValue = "not-a-date";
    input.setAttribute("value", notADateValue);

    return input.value !== notADateValue;
  }
}
